/* eslint-disable */

import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';

/**
 * Create styles used by Delivery
 * @param {Styles} styles The result of `createStyles`
 * @returns The Delivery styles
 */
const deliveryServiceStyles = ({ isLight, theme }) => ({
  deliveryServiceStatusPill: {},
  deliveryServiceStatusPillComplete: {
    backgroundColor: isLight() ? theme.palette.grey[300] : theme.palette.grey[700],
    color: theme.palette.getContrastText(isLight() ? theme.palette.grey[300] : theme.palette.grey[700]),
  },
  deliveryServiceStatusPillDelivered: {
    backgroundColor: isLight() ? theme.palette.grey[300] : theme.palette.grey[700],
    color: theme.palette.getContrastText(grey[400]),
  },
  deliveryServiceStatusPillLive: {
    backgroundColor: green[400],
    color: theme.palette.getContrastText(green[400]),
  },
  deliveryServiceStatusPillScheduled: {
    backgroundColor: orange[400],
    color: theme.palette.getContrastText(orange[400]),
  },
});

export default deliveryServiceStyles;
